import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { WarningAlert } from '@bibliocommons/alerts';

export default function ILSOfflineMessage({ availabilityError }) {
  if (availabilityError) {
    return (
      <WarningAlert className="cp-ils-offline-message">
        <FormattedMessage id="outdated_availability_error" />
      </WarningAlert>
    );
  }

  return null;
}

ILSOfflineMessage.propTypes = {
  availabilityError: PropTypes.string
};
